import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { B2bUserType } from 'shared-types/user';

import { userInitialState } from './constants';

const userSlice = createSlice({
  name: 'user',
  initialState: userInitialState,
  reducers: {
    setUserUuid: (state, action: PayloadAction<string>) => {
      state.userUuid = action.payload;
    },
    setUserType: (state, action: PayloadAction<B2bUserType>) => {
      state.userType = action.payload;
    },
    resetUser: (state) => {
      state.userUuid = null;
    },
  },
});

export const { setUserUuid, resetUser, setUserType } = userSlice.actions;

export default userSlice.reducer;
